import { motion } from "framer-motion";
import ChaletCard from "./ChaletCard";

const brl = (v) => v.toLocaleString("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 });

export default function CategorySection({ categoria, index, anchorId }) {
  const bg = index % 2 === 0 ? "bg-[#F6F5F2]" : "bg-[#EBE8E0]";
  return (
    <section
      id={anchorId}
      className={`${bg} px-6 py-20 md:px-12 md:py-28 lg:px-24`}
      data-testid={`categoria-${categoria.id}`}
    >
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="flex flex-wrap items-end gap-x-10 gap-y-4"
      >
        <div className="flex items-start gap-6">
          <span className="text-5xl font-bold text-[#8C5A40]/30 md:text-6xl">{categoria.numero}</span>
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#8C5A40]">Categoria</p>
            <h2 className="mt-2 text-3xl font-normal tracking-tight md:text-5xl">{categoria.titulo}</h2>
          </div>
        </div>
        <p className="md:ml-auto md:text-right">
          <span className="text-3xl font-bold md:text-4xl">{brl(categoria.diaria)}</span>
          <span className="text-sm text-[#5B7065]"> / diária</span>
        </p>
      </motion.div>
      <motion.p
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, delay: 0.1 }}
        className="mt-6 max-w-2xl text-base leading-relaxed text-[#5B7065] md:text-lg"
      >
        {categoria.descricao}
      </motion.p>
      <div className="mt-12 grid gap-8 md:grid-cols-2 xl:grid-cols-3">
        {categoria.chales.map((nome) => (
          <ChaletCard key={nome} nome={nome} categoria={categoria} />
        ))}
      </div>
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mt-16 border border-[#1C3026]/15 bg-white p-4 md:p-6"
      >
        <p className="mb-4 text-xs font-bold uppercase tracking-[0.25em] text-[#5B7065]">
          Mapa dos chalés — {categoria.titulo}
        </p>
        <img
          src={categoria.mapa}
          alt={`Mapa dos ${categoria.titulo}`}
          className="mx-auto max-h-[540px] w-auto max-w-full object-contain"
          data-testid={`mapa-${categoria.id}`}
        />
      </motion.div>
    </section>
  );
}
